import { Check } from "lucide-react";

import { cn } from "@/shared/lib/cn";
import {
  VENUE_ONBOARDING_STEPS,
  VENUE_STEP_LABELS,
  type VenueOnboardingStep,
} from "@/features/venue-onboarding/types";

interface Props {
  current: VenueOnboardingStep;
}

export function StepIndicator({ current }: Props) {
  const currentIndex = VENUE_ONBOARDING_STEPS.indexOf(current);
  return (
    <ol className="flex items-center gap-1">
      {VENUE_ONBOARDING_STEPS.map((step, idx) => {
        const isDone = idx < currentIndex;
        const isCurrent = idx === currentIndex;
        return (
          <li key={step} className="flex items-center gap-1">
            <span
              className={cn(
                "flex h-6 w-6 items-center justify-center rounded-full border text-xs font-semibold leading-none tabular-nums transition-colors",
                isDone && "border-primary bg-primary text-primary-foreground",
                isCurrent && "border-primary bg-primary-light text-primary",
                !isDone && !isCurrent && "border-border bg-surface text-copy-subtle",
              )}
              aria-current={isCurrent ? "step" : undefined}
            >
              {isDone ? <Check className="h-3 w-3" /> : idx + 1}
            </span>
            <span
              className={cn(
                "hidden text-xs sm:inline",
                isCurrent ? "font-semibold text-copy" : "text-copy-muted",
              )}
            >
              {VENUE_STEP_LABELS[step]}
            </span>
            {idx < VENUE_ONBOARDING_STEPS.length - 1 && (
              <span
                className={cn(
                  "ml-1 h-px w-4 sm:w-6",
                  isDone ? "bg-primary" : "bg-border",
                )}
                aria-hidden
              />
            )}
          </li>
        );
      })}
    </ol>
  );
}
